
















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RegisterDone extends Vue {
    @Prop() bearerToken!: string;
    @Prop() accountId!: string;
    @Prop() userId!: string;
}
